import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';

import {
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Col,
} from "reactstrap";
import classnames from "classnames";

import ClientsForm from "./Form"

import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';
import configApp from "../../config/config-app";
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";

function TabsForm() {
    const { id } = useParams();

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState('form');

    const profileFilter = chooseProfileFilter();
    const pathFrontEnd = '/governanceroom/clientsmanagers/';
    const paths = {
        pathAdd: pathFrontEnd+'add',
        pathEdit: pathFrontEnd+'edit',
        pathView: pathFrontEnd+'view',
        endpoint: config.endpoints.backend+'governanceroom/clientsmanagers/getall',
        endpointDelete: `${config.endpoints.backend}governanceroom/clientsmanagers/delete`
    }
    
    let list = {
        labelTitle: 'Lista de Gestores de Clientes',
        labelTitleButtonAdd: 'Incluir novo gestor de cliente',
        fieldsShowOnDelete: ['name'],
        filter: {
            ...profileFilter,
            core_application_instance_id: id
        },
        showPrintButtons: true,
        buttonsListContainer: [
            {
                name: 'send',
                class: 'btn btn-primary',
                label: 'Novo',
                tooltipLabel: 'Novo',
                callback: async () => {
                    dispatch({ type: 'UPDATE_SESSION', key: 'application_instance_id', value: id });
                    navigate(`${pathFrontEnd}add`)
                }
            }
        ],
        columns: [
            {
                name: 'name',
                label: 'Usuário'
            },            
            {
                name: 'instance_name',
                label: 'Cliente'
            },
            {
                name: 'profile_name',
                label: 'Perfil'
            }
        ],  
        ...paths 
    };


    list = { ...list, ...paths };

    return (
        <div>
            <Nav tabs>
                <NavItem>
                    <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({ active: activeTab === "form" })}
                        onClick={() => {
                            setActiveTab("form");
                        }}
                    >
                        Cliente
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({ active: activeTab === "clientscitiesmanagers" })}
                        onClick={() => {
                            setActiveTab("clientscitiesmanagers");
                        }}
                    >
                        Gestores de Clientes
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={activeTab} className="bg-white">
                <TabPane tabId="form">
                    <Col sm="12">
                        <ClientsForm />
                    </Col>
                </TabPane>
                <TabPane tabId="clientscitiesmanagers">
                    <Col sm="12">
                        <CustomListContainer
                            buttons={list.buttonsListContainer}
                            canAdd={list.canAdd}
                            pathAdd={list.pathAdd}
                            labelTitle={list.labelTitle}
                            labelTitleButtonAdd={list.labelTitleButtonAdd}
                            content={<CustomList list={{ ...list, ...paths }} />}
                        />
                    </Col>
                </TabPane>
            </TabContent>
        </div>
    );
}
export default TabsForm;
